module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticClass: "fixed-header",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n    "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('button-tab', {
    staticClass: "done-tab"
  }, [_c('button-tab-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("\n      详情列表\n    ")]), _vm._v(" "), _c('button-tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("\n      流程意见\n    ")]), _vm._v(" "), _c('button-tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab(3)
      }
    }
  }, [_vm._v("\n      查看附件\n    ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "detail-page"
    }
  }, [_c(_vm.who, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listShow),
      expression: "listShow"
    }],
    tag: "component",
    attrs: {
      "idArr": this.idArr
    }
  }), _vm._v(" "), (_vm.auditData.length > 0) ? _c('detail-msg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msgShow),
      expression: "msgShow"
    }],
    attrs: {
      "auditData": this.auditData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fileShow) ? _c('detail-file', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileShow),
      expression: "fileShow"
    }],
    attrs: {
      "fileData": _vm.fileData,
      "fileList": _vm.fileList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.defaultFileShow) ? _c('detail-default-file', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultFileShow),
      expression: "defaultFileShow"
    }],
    attrs: {
      "fileData": _vm.fileData,
      "idArr": [this.id, this.flowId, this.stepId]
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f0dd26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/DonePages.vue
// module id = VL2c
// module chunks = 0